// @ts-nocheck

class EditorialGalleryScroll {
  constructor() {
    this.galleryEl = document.querySelector('.product--gallery-editorial .product__media[data-product-gallery]');
    if (!this.galleryEl) return;

    this.desktopQuery = '(min-width: 60em)';

    this.patchMediaScroll();
    this.setupVariantSync();
    this.setupSwatchScrollTop();
  }

  setupSwatchScrollTop() {
    const swatchBtns = document.querySelectorAll('.product-form__editorial-swatch');
    if (!swatchBtns.length) return;

    swatchBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.scrollPageToTop());
    });
  }

  scrollPageToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  patchMediaScroll() {
    const wrappers = this.galleryEl.querySelectorAll('.media-wrapper[data-media-id]');
    wrappers.forEach((wrapper) => {
      wrapper.scrollIntoView = (options) => this.scrollWithinGallery(wrapper, options);
    });
  }

  scrollWithinGallery(wrapper, options) {
    if (!window.matchMedia(this.desktopQuery).matches) return;

    const galleryRect = this.galleryEl.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const top = this.galleryEl.scrollTop + (wrapperRect.top - galleryRect.top);
    const behavior = options && options.behavior ? options.behavior : 'smooth';

    this.galleryEl.scrollTo({ top, behavior });
  }

  setupVariantSync() {
    document.addEventListener('flu:product:variant-change', (event) => this.onVariantChange(event));
  }

  onVariantChange(event) {
    if (window.matchMedia(this.desktopQuery).matches) return;

    const variant = event.detail && event.detail.variant;
    if (!variant || !variant.featured_media) return;

    const wrapper = this.galleryEl.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
    if (!wrapper) return;

    this.scrollWithinGalleryHorizontal(wrapper);
  }

  scrollWithinGalleryHorizontal(wrapper) {
    const galleryRect = this.galleryEl.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const left = this.galleryEl.scrollLeft + (wrapperRect.left - galleryRect.left);

    this.galleryEl.scrollTo({ left, behavior: 'smooth' });
  }
}

new EditorialGalleryScroll();
